import React from 'react';
import PropTypes from 'prop-types';

import { Layout } from 'antd';

const { Footer } = Layout;

function CustomFooter(props) {
	return (
		<Footer style={{ textAlign: 'center' }}>
		Generali ©2019-2020
		</Footer>
	);
}

export default CustomFooter;
